import type { UserCompany } from '@/features/auth/types/auth.types';

export function enabledCompanies(companies: UserCompany[]): UserCompany[] {
  return companies.filter((company) => (company.status ?? 'enabled').toLowerCase() === 'enabled');
}

export function resolveActiveCompany(companies: UserCompany[], customerUuid?: string | null): UserCompany | null {
  if (!customerUuid) return null;
  return companies.find((company) => company.customer_uuid === customerUuid) ?? null;
}

export function pickPreselectedCompany(
  companies: UserCompany[],
  lastCustomerUuid?: string | null
): { company: UserCompany | null; lastUnavailable: boolean } {
  if (companies.length === 0) return { company: null, lastUnavailable: false };
  const last = resolveActiveCompany(companies, lastCustomerUuid);
  if (last) return { company: last, lastUnavailable: false };
  return { company: companies[0] ?? null, lastUnavailable: Boolean(lastCustomerUuid) };
}
